import Color from 'color';
import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';

export class KindPillIcon extends Field {
  static subqueriesForModel() {
    return { workflowKind: ['iconName', 'color'] };
  }

  get title() {
    return 'Type icon with colored background';
  }

  exampleContents(): FieldContentsData {
    return {
      icon: {
        name: 'fa-solid fa-bug',
        color: 'white',
        backgroundColor: '#C9250E',
        className: `record-reference-pill__icon`,
      },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.workflowKind) {
      return {
        icon: {
          name: `fa-solid ${record.workflowKind.iconName}`,
          color: 'white',
          backgroundColor: Color(record.workflowKind.color).hex(),
          className: `record-reference-pill__icon`,
          rounded: true,
        },
      };
    }

    return {};
  }
}
